export default __webpack_public_path__ + "static/media/stripe-logo.fb148ac1.svg";